import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import { styled } from '@classify/react-core-components/styles';
import cx from 'classnames';
import { alpha } from '@classify/react-core-components/styles';
import browser from '@openclassrooms/utils/browser';
const PREFIX = 'HorizontalScroller';
const classes = {
  root: `${PREFIX}-root`,
  container: `${PREFIX}-container`,
  shadow: `${PREFIX}-shadow`,
  leftShadow: `${PREFIX}-leftShadow`,
  rightShadow: `${PREFIX}-rightShadow`
};
const Root = styled('div')(({
  theme: {
    palette
  }
}) => ({
  [`&.${classes.root}`]: {
    zIndex: 0,
    display: 'block',
    transition: 'all 0.1s linear 0s',
    boxSizing: 'border-box',
    marginTop: '0 !important',
    width: '100%',
    left: 0,
    position: 'relative'
  },
  [`& .${classes.container}`]: {
    overflowX: 'auto'
  },
  [`&.${classes.shadow}`]: {
    '&::before, &::after': {
      top: 0,
      bottom: 0,
      height: '100%',
      zIndex: 11,
      width: 8,
      position: 'absolute',
      display: 'none'
    }
  },
  [`&.${classes.leftShadow}`]: {
    '&::before': {
      left: 0,
      display: 'block',
      background: `linear-gradient(to right, ${alpha(palette.text.secondary, 0.24)} 0%, transparent 100%)`,
      content: '""'
    }
  },
  [`&.${classes.rightShadow}`]: {
    '&::after': {
      right: 0,
      display: 'block',
      background: `linear-gradient(to left, ${alpha(palette.text.secondary, 0.24)} 0%, transparent 100%)`,
      content: '""'
    }
  }
}));
export function HorizontalScroller(t0) {
  const $ = _c(12);
  const {
    children
  } = t0;
  const [showLeftShadow, setShowLeftShadow] = useState(false);
  const [showRightShadow, setShowRightShadow] = useState(false);
  const [container, setContainer] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      const node = e?.target || e;
      if (!node) {
        return;
      }
      setContainer(node);
      const {
        scrollWidth,
        scrollLeft,
        clientWidth
      } = node;
      setShowLeftShadow(scrollLeft > 0);
      setShowRightShadow(scrollWidth - clientWidth !== scrollLeft);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const updateShadows = t1;
  let t2;
  let t3;
  if ($[1] !== container) {
    t2 = () => {
      const onResize = () => {
        updateShadows(container);
      };
      browser.window.addEventListener("resize", onResize);
      return () => {
        browser.window.removeEventListener("resize", onResize);
      };
    };
    t3 = [container];
    $[1] = container;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== showLeftShadow || $[5] !== showRightShadow) {
    t4 = cx(classes.root, classes.shadow, {
      [classes.leftShadow]: showLeftShadow,
      [classes.rightShadow]: showRightShadow
    });
    $[4] = showLeftShadow;
    $[5] = showRightShadow;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children) {
    t5 = <div className={classes.container} ref={updateShadows}>{children}</div>;
    $[7] = children;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <Root className={t4} onScroll={updateShadows}>{t5}</Root>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
export default HorizontalScroller;